module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5a931b14b2d580d278cc65be8822a77a.png";